import React, { Component } from "react";
import undraw_programming_animated from "../../assests/images/undraw_programming_animated.svg"

class FeelingProud extends Component {
  render() {
    const theme = this.props.theme;
    return (
        <object type="image/svg+xml" data={undraw_programming_animated}>svg-animation</object>
    );
  }
}

export default FeelingProud;
